/** File collection remains available during closing; posting has stricter rules. */
export function canUploadDocuments(companyRole?: string, projectRole?: string, period?: { is_locked?: boolean; period_status?: string | null }) {
  return ["member", "admin", "owner"].includes(companyRole ?? "") && ["editor", "owner"].includes(projectRole ?? "") &&
    !period?.is_locked && !["closed", "locked"].includes(period?.period_status ?? "")
}
